import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetBoxComponent } from '../../widgets/box/box.component';
import { WidgetButtonComponent } from '../../widgets/button/button.component';
import { WidgetDataComponent } from '../../widgets/data/data.component';
import { AppConnectComponent } from '../connect/connect.component';
import { AppSwitchComponent } from '../switch/switch.component';
import { PipeAddress } from '../../pipes/address.pipe';
import { PipeAmount } from '../../pipes/amount.pipe';
import { AlphaHelper } from '../../helpers/alpha.helper';
import { ModalHelper } from '../../helpers/modal.helper';
import { WalletHelper } from '../../helpers/wallet.helper';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  imports: [
    CommonModule,
    WidgetBoxComponent,
    WidgetButtonComponent,
    WidgetDataComponent,
    PipeAddress,
    PipeAmount,
  ]
})
export class AppAccountComponent {

  /**
   * Alpha helper
   */
  alpha_helper = inject(AlphaHelper);

  /**
   * Modal helper
   */
  modal_helper = inject(ModalHelper);

  /**
   * Wallet helper
   */
  wallet_helper = inject(WalletHelper);

  /**
   * Active account
   */
  active_account = computed(() => this.wallet_helper.active_account());

  /**
   * Account coins balance
   */
  coins_balance = computed(() => this.wallet_helper.coins_balance());

  /**
   * Account tokens balance
   */
  tokens_balance = computed(() => this.wallet_helper.tokens_balance());

  /**
   * Open wallet modal
   */
  openWallet() {
    if (this.active_account()) {
      this.modal_helper.open(AppSwitchComponent, 'Manage Account', {});
    } else {
      this.modal_helper.open(AppConnectComponent, 'Connect Wallet', {});
    }
  }
}
